import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowCircleDown = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M36 20c0 8.839-7.161 16-16 16S4 28.839 4 20 11.161 4 20 4s16 7.161 16 16Zm-9.265-1.864-4.67 4.87v-11.78c0-.858-.69-1.549-1.549-1.549h-1.032c-.858 0-1.549.69-1.549 1.549v11.78l-4.67-4.87a1.55 1.55 0 0 0-2.213-.026l-.704.71a1.542 1.542 0 0 0 0 2.186l8.555 8.562a1.542 1.542 0 0 0 2.187 0l8.568-8.562a1.542 1.542 0 0 0 0-2.187l-.703-.71c-.62-.612-1.62-.6-2.22.026Z" })
});
export default SvgArrowCircleDown;
